type TableCellContentUnknownProps = {
  isEditing: boolean;
  value?: unknown;
};

export const TableCellContentUnknown: React.FC<
  TableCellContentUnknownProps
> = ({ isEditing, value }) => {
  return <>{isEditing ? <> </> : <p>{String(value ?? "")}</p>}</>;
};
